import React from 'react';
import loadingSpinner from '../assets/loading-spinner.svg';

interface AppLoaderProps {
  message?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({message = 'Loading XPSR...'}) => {
  return (
    <div className="app-loader" role="status" aria-live="polite" aria-label={message}>
      <div className="app-loader__card">
        <img
          src={loadingSpinner}
          alt=""
          className="app-loader__image"
          width={96}
          height={96}
        />
        <p className="app-loader__text">{message}</p>
      </div>
    </div>
  );
};

export default AppLoader;
